import type { Release } from '../releases';

export default {
  id: '2026-11-02-cashflow-fin-plan',
  at: '2026-11-03T05:02:00Z',
  title: 'ДДС: персонал, налоги и комиссии гарантий, поступления от заказчика',
  modules: ['finance'],
  items: [
    'В ДДС проекта появились расходы на персонал, административные расходы и налоги — по месяцам из утверждённого финансового плана проекта, начиная с сегодняшнего дня. По неделям сумма месяца раскладывается по дням. Эти суммы видны с уровнем денег «Все», как и сам финансовый план.',
    'Комиссии действующих банковских гарантий и аккредитивов по договорам с заказчиком стоят в ДДС на дату выдачи.',
    'Исправлено: платежи заказчика по графикам договоров не попадали в ДДС. Теперь поступления видны.',
    'В блоке «Платежи» — разбивка: договоры и заявки, персонал, административные расходы, налоги, комиссии гарантий. Внизу видно, из какого ФП взяты суммы и у каких проектов утверждённого ФП нет.',
  ],
  why: 'ДДС показывал только платежи по договорам: зарплата, налоги и поступления от заказчика в нём не отражались, и кассовые разрывы получались неверными.',
  link: '/finance?tab=cashflow',
} satisfies Release;
